export default __webpack_public_path__ + "static/media/Meine Stoffstrombilanzen.81b3a299.jpg";